import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';


const ReconcileEntry = ({ code, caption }) => {
  //console.log(`caption: ${caption} users: ${users} roles: ${roles}`)

  const [invoiceNumber, setInvoiceNumber] = useState('');
  const [invoiceYear, setInvoiceYear] = useState('');
  const [supplierCode, setSupplierCode] = useState('');
  const [includeClosed, setIncludeClosed] = useState(false);

  const navigate = useNavigate();

  const [errors, setErrors] = useState({});

  const validate = () => {
    const newErrors = {};
    const trimmedSupplier = supplierCode.trim();
    const trimmedInvoice = invoiceNumber.trim();
    const trimmedYear = invoiceYear.trim();


    if (!trimmedSupplier) {
      newErrors.supplierCode = 'Inserisci il codice Fornitore Es. 251511742';
    }

    if (!trimmedYear) {
      newErrors.invoiceYear = `Inserisci l'anno della fattura`;
    } else {
      const yearNum = parseInt(trimmedYear, 10);
      const currentYear = new Date().getFullYear();

      if (isNaN(yearNum)) {
        newErrors.invoiceYear = `L'anno deve essere numerico`;
      } else if (yearNum < 2000 || yearNum > currentYear + 1) {
        newErrors.invoiceYear = `L'anno deve essere compreso tra 2000 e ${currentYear}`;
      }
    }

    if (!trimmedInvoice) {
      newErrors.invoiceNumber = 'Inserisci il numero della fattura Es. FTV26006971';
    }
    console.log(newErrors)
    return newErrors;
  }


  /*
    NOTA:
    col-md-4 in Bootstrap sfora, quindi messo col-md-3

  */

  return (
    <div className="container my-5">
      <div className="card p-3">
        <h5 className="card-title"> {caption} </h5>

        <div className="row align-items-start g-2">

          {/*Colonna input FORNITORE*/}
          <div className="col-md-3 mb-3 position-relative">
            <label className="form-label">Codice Fornitore</label>
            <input
              type="text"
              className={`form-control ${errors.supplierCode ? 'is-invalid' : ''}`}
              value={supplierCode}
              placeholder="Es. 251511742"
              onChange={(e) => setSupplierCode(e.target.value)}
            />
            {errors.supplierCode && (
              <div className="invalid-tooltip">
                {errors.supplierCode}
              </div>
            )}
          </div>

          {/*Colonna input ANNO*/}
          <div className="col-md-1 mb-3 position-relative">
            <label className="form-label">Anno</label>
            <input
              type="text"
              className={`form-control ${errors.invoiceYear ? 'is-invalid' : ''}`}
              value={invoiceYear}
              placeholder="2026"
              onChange={(e) => setInvoiceYear(e.target.value)}
            />
            {errors.invoiceYear && (
              <div className="invalid-tooltip">
                {errors.invoiceYear}
              </div>
            )}
          </div>

          {/*Colonna input FATTURA*/}
          <div className="col-md-3 mb-3 position-relative">
            <label className="form-label">Numero fattura</label>
            <input
              type="text"
              className={`form-control ${errors.invoiceNumber ? 'is-invalid' : ''}`}
              value={invoiceNumber}
              placeholder="Es. FTV26006971"
              onChange={(e) => setInvoiceNumber(e.target.value)}
            />
            {errors.invoiceNumber && (
              <div className="invalid-tooltip">
                {errors.invoiceNumber}
              </div>
            )}
          </div>

          {/*Colonna CHECKBOX per DDT aperti o tutti*/}
          <div className="col-md-3 mb-3">
            <label className="form-label">DDT da considerare</label>

            <div className="form-control d-flex align-items-center" style={{ height: '38px' }}>
              <input
                className="form-check-input me-2"
                type="checkbox"
                id="includeClosed"
                checked={includeClosed}
                onChange={(e) => setIncludeClosed(e.target.checked)}
              />
              <label className="form-check-label mb-0" htmlFor="includeClosed">
                Includi anche chiusi
              </label>
            </div>
          </div>

          {/*Colonna BOTTONE per RICONCILIAZIONE col-md-3 mb-3 text-end*/}
          {/*disabled={invoiceNumber.trim() === ''}*/}
          <div className="col-md-2 mb-3 align-self-end">
            <button
              type="button"
              className="btn btn-primary w-100"
              onClick={() => {
                /*
                  NOTE:
                  > passiamo querystring che viene letta
                  > potremmo passare i props navigate(`/reconcile?${qs}`, { state: { caption, users, roles } });
                    e poi in ReconcilePage:
                      const location = useLocation();
                      const { caption, users, roles } = location.state || {};
                    ma location.state poi sparisce al refresh, es con F5
                    UNSAFE: utente malizioso può iniettare i ruoli
                */
                const validationErrors = validate();
                if (Object.keys(validationErrors).length > 0) {
                  setErrors(validationErrors);
                }
                else {
                  setErrors({}); // Clean State, tabula rasa

                  const qs = new URLSearchParams({
                    reportCode: code,
                    supCode: supplierCode.trim(),
                    docYear: invoiceYear.trim(),
                    docNumExt: invoiceNumber.trim(),
                    includeClosedDdt: includeClosed
                  }).toString();

                  navigate(`/reconcile?${qs}`);
                }

              }}
            >
              <FontAwesomeIcon icon="eye" />
              Apri Riconciliazione

            </button>

          </div>

        </div>

      </div>
    </div>
  );

};

export default ReconcileEntry;
